import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TopProductsCatalogApiService from "@/core/services/api.service.top-products-catalog";
import moment from "moment";
import TopProductPopup from "./top-product-popup/top-product-popup.vue";
import CreateTopProductPopup from "./create-top-product-popup/create-top-product-popup.vue";

export default {
  components: {
    TopProductPopup,
    CreateTopProductPopup
  },
  props: {
    modal: {
      default: false
    },
    value: Boolean
  },
  name: "top-products-catalog",
  data() {
    return {
      pageSizes: [10, 20, 50, 100],
      shopId: null,
      itemId: null,
      itemSelectionGroupId: null,
      search: "",
      totalProducts: 0,
      products: [],
      itemSelectionGroups: [],
      loading: false,
      pagination: {},
      errors: [],
      apiInitialized: false,
      expanded: [],
      confirmDeleteDialog: false,
      productToDelete: null,
      showProductPopup: false,
      selectedProduct: null,
      showAddProductDialog: false,
      selectedItems: [],
      confirmBulkDeleteDialog: false,
      changeGroupDialog: false,
      itemToChangeGroup: null,
      newGroupId: null
    };
  },
  computed: {
    name() {
      return "Top Products Catalog";
    },
    headersMobile() {
      return [
        {
          text: "Item ID",
          align: "start",
          value: "itemId",
          width: "15%"
        },
        { text: "Title", value: "itemTitle", sortable: false, width: "40%" },
        {
          text: "Price",
          value: "price",
          sortable: false,
          width: "20%"
        },
        {
          text: "Group",
          value: "groupName",
          sortable: false,
          width: "25%"
        }
      ];
    },
    headers() {
      return [
        { text: "", value: "select", sortable: false, width: "3%", align: "center" },
        { text: "Item ID", value: "itemId", sortable: false, width: "6%" },
        { text: "Image", value: "itemImage", sortable: false, width: "6%", align: "center" },
        { text: "Title", value: "itemTitle", sortable: false, width: "16%" },
        { text: "SKU", value: "sku", sortable: false, width: "9%" },
        {
          text: "Shop",
          value: "shopName",
          sortable: false,
          width: "10%"
        },
        {
          text: "Price",
          value: "price",
          sortable: false,
          width: "7%",
          align: "center"
        },
        {
          text: "Stock",
          value: "inStock",
          sortable: false,
          width: "6%",
          align: "center"
        },
        {
          text: "Selection Group",
          value: "groupName",
          sortable: false,
          width: "11%"
        },
        {
          text: "Created At",
          value: "createdAt",
          sortable: false,
          width: "11%",
          align: "center"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "7%",
          align: "center"
        }
      ];
    },
    allItemSelectionGroups() {
      return this.itemSelectionGroups.map(group => ({
        customText: group.name,
        value: group.id
      }));
    },
    activeFiltersCount() {
      let count = 0;
      if (this.shopId) count++;
      if (this.itemId) count++;
      if (this.itemSelectionGroupId) count++;
      return count;
    },
    allSelected() {
      return this.products.length > 0 && this.selectedItems.length === this.products.length;
    },
    someSelected() {
      return this.selectedItems.length > 0 && !this.allSelected;
    },
    variationHeaders() {
      return [
        { text: "SKU", value: "sku", sortable: false, width: "10%" },
        { text: "EAN", value: "ean", sortable: false, width: "10%" },
        {
          text: "Purchase Price",
          value: "purchasePrice",
          sortable: false,
          width: "12%",
          align: "center"
        },
        {
          text: "Selling Price",
          value: "sellingPrice",
          sortable: false,
          width: "12%",
          align: "center"
        },
        {
          text: "Discounted Price",
          value: "discountedPrice",
          sortable: false,
          width: "12%",
          align: "center"
        },
        { text: "Quantity", value: "quantity", sortable: false, width: "10%", align: "center" },
        {
          text: "Reserved",
          value: "reservedQuantity",
          sortable: false,
          width: "10%",
          align: "center"
        },
        { text: "Properties", value: "properties", sortable: false, width: "12%" },
        { text: "Discounts", value: "discounts", sortable: false, width: "12%" }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        if (this.apiInitialized) {
          this.retrieveProducts();
        }
      },
      deep: true
    },
    pagination: {
      handler() {
        if (this.apiInitialized) {
          this.retrieveProducts();
        }
      },
      deep: true
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "dashboard" },
      { title: "Top Products" }
    ]);

    try {
      await TopProductsCatalogApiService.init();
      this.apiInitialized = true;
      await this.retrieveProducts();
      await this.getItemSelectionGroups();
    } catch (error) {
      console.error("Failed to initialize TopProductsCatalogApiService:", error);
      this.$bvToast?.toast("Failed to initialize API service", {
        variant: "danger",
        solid: true,
        autoHideDelay: 3000
      });
    }
  },
  methods: {
    /* eslint-disable */
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("DD.MM.YYYY HH:mm");
    },

    getRequestParams() {
      let params = {};

      if (this.shopId) {
        params["shopId"] = this.shopId;
      }

      if (this.itemId) {
        params["itemId"] = this.itemId;
      }

      if (this.itemSelectionGroupId) {
        params["itemSelectionGroupId"] = this.itemSelectionGroupId;
      }

      params["page"] = this.pagination.page ? this.pagination.page - 1 : 0;
      params["size"] = this.pagination.itemsPerPage || 10;

      return params;
    },

    clearSearch() {
      this.shopId = null;
      this.itemId = null;
      this.itemSelectionGroupId = null;
      this.retrieveProducts();
    },

    async getItemSelectionGroups() {
      try {
        const response = await TopProductsCatalogApiService.getAllItemSelectionGroups({
          page: 0,
          size: 100
        });
        this.itemSelectionGroups = response.data.content || [];
      } catch (error) {
        console.error("Error fetching item selection groups:", error);
      }
    },

    retrieveProducts() {
      const params = this.getRequestParams();

      return new Promise(resolve => {
        this.loading = true;
        TopProductsCatalogApiService.getAllItemSelections(params)
          .then(response => {
            this.products = response.data.content.map(item => ({
              id: item.id,
              itemId: item.itemId,
              itemTitle: item.item?.title || "-",
              itemImage: item.item?.imageUrl || "",
              sku: item.item?.sku || null,
              shopName: item.item?.shop?.name || "-",
              shopId: item.item?.shop?.id || null,
              price: item.item?.price || 0,
              inStock: item.item?.inStock || 0,
              groupId: item.itemSelectionGroup?.id || null,
              groupName: item.itemSelectionGroup?.name || "-",
              itemSelectionGroupId: item.itemSelectionGroup?.id || null,
              createdAt: item.createdAt,
              createdBy: item.createdBy,
              deleted: item.deleted,
              itemData: item.item,
              itemSelectionGroup: item.itemSelectionGroup || {}
            }));

            this.totalProducts = response.data.totalElements;
            this.loading = false;
            let title = this.totalProducts;
            this.$store.dispatch(SET_BREADCRUMB, [{ title: `${this.name}: ` + title }]);
            resolve();
          })
          .catch(error => {
            console.error("Error fetching products: ", error);
            this.loading = false;
            reject(error);
          });
      });
    },

    deleteProduct(id) {
      this.productToDelete = id;
      this.confirmDeleteDialog = true;
    },

    async confirmDelete() {
      if (!this.productToDelete) {
        return;
      }
      const id = this.productToDelete;

      try {
        this.loading = true;
        await TopProductsCatalogApiService.deleteItemSelection(id);
        this.$bvToast?.toast("Product removed successfully", {
          variant: "success",
          solid: true,
          autoHideDelay: 3000
        });
        await this.retrieveProducts();
      } catch (error) {
        console.error("Error deleting product:", error);
        this.$bvToast?.toast("Failed to remove product", {
          variant: "danger",
          solid: true,
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
        this.confirmDeleteDialog = false;
        this.productToDelete = null;
      }
    },

    toggleRow(item) {
      const index = this.expanded.indexOf(item);
      if (index > -1) {
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },

    viewProductDetails(product) {
      this.selectedProduct = product;
      this.showProductPopup = true;
    },

    openAddProductDialog() {
      this.showAddProductDialog = true;
    },

    handleProductAdded() {
      this.showAddProductDialog = false;
      this.retrieveProducts();
    },

    handleGroupCreated(newGroup) {
      // Add the new group to the list
      this.itemSelectionGroups.push(newGroup);
    },

    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [...this.products];
      }
    },

    toggleSelectItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }
    },

    isItemSelected(item) {
      return this.selectedItems.some(i => i.id === item.id);
    },

    openBulkDeleteDialog() {
      if (this.selectedItems.length === 0) {
        this.$bvToast?.toast("Please select at least one item to delete", {
          variant: "warning",
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }
      this.confirmBulkDeleteDialog = true;
    },

    async confirmBulkDelete() {
      if (this.selectedItems.length === 0) return;

      try {
        this.loading = true;
        const ids = this.selectedItems.map(item => item.id);

        await TopProductsCatalogApiService.deleteBulkItemSelections(ids);

        this.$bvToast?.toast(`Successfully deleted ${ids.length} item(s)`, {
          variant: "success",
          solid: true,
          autoHideDelay: 3000
        });

        this.selectedItems = [];
        this.confirmBulkDeleteDialog = false;
        await this.retrieveProducts();
      } catch (error) {
        console.error("Error deleting items:", error);
        this.$bvToast?.toast("Failed to delete selected items", {
          variant: "danger",
          solid: true,
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
      }
    },

    openChangeGroupDialog(item) {
      this.itemToChangeGroup = item;
      this.newGroupId = item.itemSelectionGroupId;
      this.changeGroupDialog = true;
    },

    closeChangeGroupDialog() {
      this.changeGroupDialog = false;
      this.itemToChangeGroup = null;
      this.newGroupId = null;
    },

    async confirmChangeGroup() {
      if (!this.itemToChangeGroup || !this.newGroupId) return;

      try {
        this.loading = true;
        await TopProductsCatalogApiService.updateItemSelection(this.itemToChangeGroup.id, {
          itemSelectionGroupId: this.newGroupId,
          itemId: this.itemToChangeGroup.itemId
        });

        this.$bvToast?.toast("Selection group updated successfully", {
          variant: "success",
          solid: true,
          autoHideDelay: 3000
        });

        this.closeChangeGroupDialog();
        await this.retrieveProducts();
      } catch (error) {
        console.error("Error updating selection group:", error);
        this.$bvToast?.toast("Failed to update selection group", {
          variant: "danger",
          solid: true,
          autoHideDelay: 3000
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
